export { default } from "./PopularSearch.jsx";
